import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function Bonos() {
  const bonos = [{
    icon: '🚫',
    image: 'https://i.postimg.cc/zfZDggQJ/libro-bono-1.webp',
    title: 'Lista Negra del Reflujo',
    desc: 'Los alimentos que más disparan acidez, ordenados por nivel de agresividad. No una lista genérica: una guía con explicación de por qué cada uno afecta el reflujo.',
    value: '$4.990'
  }, {
    icon: '🌙',
    image: 'https://i.postimg.cc/90nCFR9p/libro-bono-2.webp',
    title: 'Guía Express de Cena Sin Castigo',
    desc: 'Cómo cenar sin provocar reflujo nocturno. Combinaciones recomendadas, horarios estratégicos y el ritual pre-sueño del Protocolo de Reprogramación Digestiva™.',
    value: '$4.990'
  }, {
    icon: '⚡',
    image: 'https://i.postimg.cc/mDdG8z8K/libro-bono-3.webp',
    title: 'Protocolo de Emergencia Anti-Agrura',
    desc: 'Qué hacer en los próximos 10 minutos cuando el ardor aparece de golpe. Un protocolo de acción inmediata para cortarlo antes de que se convierta en una crisis.',
    value: '$4.990'
  }];
  return <section id="bonos" className="py-[100px] bg-gradient-to-b from-[#120806] to-[#1a0f08]" data-id="element-103">
      <div className="container-custom" data-id="element-104">
        <SectionHeader eyebrow="Bonos incluidos" title={<>
              3 bonos exclusivos que
              <br data-id="element-106" />
              <span className="text-gold" data-id="element-107">multiplican los resultados</span>
            </>} description="Diseñados para situaciones reales que enfrentan las personas con reflujo todos los días." data-id="element-105" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-[60px]" data-id="element-108">
          {bonos.map((bono, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-gold/5 border border-gold/15 rounded-[12px] p-[32px_24px] relative transition-all duration-300 hover:border-gold/40 hover:-translate-y-1 hover:shadow-[0_20px_60px_rgba(200,150,62,0.15)]" data-id="element-109">
              <span className="absolute -top-[10px] right-5 bg-gradient-to-br from-gold to-gold-light text-deep text-[10px] font-bold tracking-[1px] px-3 py-1 rounded-full" data-id="element-110">
                HOY GRATIS
              </span>
              <div className="w-full aspect-[3/4] rounded-[8px] overflow-hidden mb-5 bg-gradient-to-br from-gold/10 to-transparent" data-id="element-111">
                <img src={bono.image} alt={bono.title} className="w-full h-full object-contain animate-float" loading="lazy" style={{
              animationDelay: `${idx * 0.5}s`
            }} data-id="element-112" />
              </div>
              <h3 className="font-display text-[18px] text-white mb-2.5 font-bold" data-id="element-113">
                {bono.title}
              </h3>
              <p className="text-[13px] text-gray leading-[1.6] mb-4" data-id="element-114">
                {bono.desc}
              </p>
              <div data-id="element-115">
                <span className="text-[12px] text-gray line-through mr-2" data-id="element-116">
                  {bono.value}
                </span>
                <span className="text-[13px] text-gold font-semibold" data-id="element-117">
                  ✦ INCLUIDO
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 max-w-[600px] mx-auto bg-gold/5 border border-gold/20 rounded-[12px] p-8 text-center" data-id="element-118">
          <p className="text-[13px] text-gray uppercase tracking-[1px] mb-2" data-id="element-119">
            Valor total de los 3 bonos:
          </p>
          <p className="font-display text-[28px] font-black text-gray line-through mb-1" data-id="element-120">
            $14.970
          </p>
          <p className="text-[15px] text-gold font-semibold" data-id="element-121">
            Hoy incluidos GRATIS con tu compra
          </p>
        </motion.div>
      </div>
    </section>;
}